export class HideCancelledItemsValueConverter {

    toView(items, hide) {
        if (!hide || !items) {
            return items;
        }

        return items.filter(item => {
            if (item.hidden) {
                return false;
            }

            const hasPrice = item.itemPriceWithOptions && item.itemPriceWithOptions.amount;
            const cancelledWithoutPrice = ('cancelled' === item.bookingStatus || 'requestDenied' === item.bookingStatus || 'notConfirmed' === item.bookingStatus) && !hasPrice;

            return !cancelledWithoutPrice;
        });
    }

}
